module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block]
  }, [_c('div', {
    class: [_vm.block + '-container']
  }, [_c('Logo', {
    class: [_vm.block + '-logo'],
    on: {
      "logoClicked": _vm.closeNavigation
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-getStarted', {
      'hidden': _vm.pagePath === '/newcustomer'
    }]
  }, [_c('ButtonBlock', {
    attrs: {
      "blockModifiers": ['smallFont', 'hoverHightlight'],
      "text": 'Get started'
    },
    nativeOn: {
      "click": function($event) {
        _vm.openGetStartedMenu($event)
      }
    }
  })], 1), _vm._v(" "), _c('Get-Started', {
    attrs: {
      "data": {
        visible: _vm.getStartedMenuOpen,
        buttonText: 'Submit',
        mailto: 'info@spotin.com',
        subject: 'Get started',
        body: '',
        name: 'Name',
        email: 'Email (required)',
        phone: 'Phone',
        companyName: 'Company name',
        allowStoreData: false,
        message: 'Short on what you are looking for with Spotin.',
        sentHtml: 'Thank you for reaching out to us at Spotin.<br>We\'ll get back to you shortly.',
      }
    },
    on: {
      "getStartedClosed": _vm.closeGetStartedMenu
    }
  }), _vm._v(" "), _c('Hamburger')], 1), _vm._v(" "), _c('Navigation', {
    attrs: {
      "data": {
        active: null
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04e1da01","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./fixed/Header.vue
// module id = 561
// module chunks = 0